import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import ShiftDetailComponent from './ShiftDetailComponent';
import { isValidObject } from 'helpers/validation';
import { appOperations } from 'App/duck';

const mapStateToProps = ({ scheduleCalendarReducer, setupReducer }) => ({
  allUsers: scheduleCalendarReducer.allUsers.users,
  applicants: scheduleCalendarReducer.applicants.data,
  isVTOConfigured: setupReducer.setup_actions?.meta?.current_location?.cfg_vto || false,
  // isVTOConfigured: false,
});

const mapDispatchToProps = (dispatch) => ({

  loadLocationRolesDispatch : (locationId) => 
    dispatch(appOperations.fetchLocationRolesOperation(locationId)),

  loadLocationSkillsDispatch: (locationId) => 
    dispatch(scheduleCalendarOperations.getLocationUsableSkills(locationId)),

  loadApplicantsForShiftDispatch: (shiftId) =>
    dispatch(scheduleCalendarOperations.fetchApplicantsForShiftOperation(shiftId)),

  fetchSingleShiftOperation: (shiftId) =>
    dispatch(scheduleCalendarOperations.fetchSingleShiftForInAppOperation(shiftId)),
});

const ShiftDetailComponentContainer = ({
  shiftId,
  presentedShift: propPresentedShift,
  fetchSingleShiftOperation,
  allUsers,
  applicants,
  cancelModal,
  loadApplicantsForShiftDispatch,
  loadLocationRolesDispatch,
  loadLocationSkillsDispatch,
  locationId,
  isVTOConfigured,
  creationType,
  ...rest
}) => {
  const [presentedShift, setPresentedShift] = useState(propPresentedShift || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isValidObject(propPresentedShift) && shiftId) {
      setError(null);
      setLoading(true);
      fetchSingleShiftOperation(shiftId)
        .then((shift) => {

          if (shift instanceof Error) {
            const statusCode = shift?.response?.status ?? shift?.status;
            if (statusCode === 404) {
              setError('This shift is no longer available to view. It may have been deleted.');
            } else {
              setError('Oops! Something went wrong. Please try again.');
            }
          } else if (shift && (shift.name == 'shift' || shift.name == 'open_shift')) {
            setPresentedShift(shift);
          }
        })
        .catch((err) => {
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [shiftId, propPresentedShift, fetchSingleShiftOperation]);

  return (
    <ShiftDetailComponent
      {...rest}
      allUsers={allUsers}
      applicants={applicants}
      presentedShift={presentedShift}
      loading={loading}
      error={error}
      clearError={() => {
        setError(null);
        cancelModal();          // this will unmount the detail view entirely
      }}
      cancelModal={cancelModal}
      loadApplicantsForShiftDispatch={loadApplicantsForShiftDispatch}
      loadLocationRolesDispatch = {loadLocationRolesDispatch}
      loadLocationSkillsDispatch={loadLocationSkillsDispatch}
      locationId={locationId}
      isVTOConfigured={isVTOConfigured}
      creationType={creationType}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftDetailComponentContainer);
